
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    scrollToSection(sectionId);
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/bbcc86dc4c3a385b7f9b9f3a7e24f053/90b51af23e16826253f35e698bc8450c.png" 
                alt="tek RVA" 
                className="h-8 w-auto"
              />
              <span className="text-xl font-bold text-white">tek RVA</span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Empowering Virginia nonprofits with reliable, secure, and cost-effective IT solutions. 
              Let us handle your technology so you can focus on your mission.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><a href="#services" onClick={(e) => handleLinkClick(e, 'services')} className="text-gray-300 hover:text-white cursor-pointer transition-colors duration-200" aria-label="Navigate to Managed IT services">Managed IT</a></li>
              <li><a href="#services" onClick={(e) => handleLinkClick(e, 'services')} className="text-gray-300 hover:text-white cursor-pointer transition-colors duration-200" aria-label="Navigate to Cybersecurity services">Cybersecurity</a></li>
              <li><a href="#services" onClick={(e) => handleLinkClick(e, 'services')} className="text-gray-300 hover:text-white cursor-pointer transition-colors duration-200" aria-label="Navigate to Cloud Solutions services">Cloud Solutions</a></li>
              <li><a href="#services" onClick={(e) => handleLinkClick(e, 'services')} className="text-gray-300 hover:text-white cursor-pointer transition-colors duration-200" aria-label="Navigate to Help Desk services">Help Desk</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><a href="#about" onClick={(e) => handleLinkClick(e, 'about')} className="text-gray-300 hover:text-white cursor-pointer transition-colors duration-200" aria-label="Navigate to About Us section">About Us</a></li>
              <li><a href="#client-portal" onClick={(e) => handleLinkClick(e, 'client-portal')} className="text-gray-300 hover:text-white cursor-pointer transition-colors duration-200" aria-label="Navigate to Client Support section">Client Support</a></li>
              <li><a href="#contact" onClick={(e) => handleLinkClick(e, 'contact')} className="text-gray-300 hover:text-white cursor-pointer transition-colors duration-200" aria-label="Navigate to Contact section">Contact</a></li>
              <li><a href="#consultation" onClick={(e) => handleLinkClick(e, 'consultation')} className="text-gray-300 hover:text-white cursor-pointer transition-colors duration-200" aria-label="Navigate to Free Consultation section">Free Consultation</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 tek RVA. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-teal-400 text-sm cursor-pointer transition-colors duration-200" aria-label="Visit Readdy.ai website builder">
              Website Builder
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
